import http from '../../../utils/fetch';

export default {
    baseurl:'/api/swyl/v1/claimRecord/bscClaimRecord',
    selectPage(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    selectClaimPage(query){
        return http({
            url: this.baseurl+'/selectClaimPage',
            method: 'post',
            params: query
        });
    },
    saveClaimRecord(data){
        return http({
            url: this.baseurl+'/saveClaimRecord',
            method: 'post',
            data: data
        });
    },
    contractOrderPage(query){
        return http({
            url: this.baseurl+'/contractOrderPage',
            method: 'post',
            params: query
        });
    },
}